import { createReducer } from '@reduxjs/toolkit' ;
import { getPayoutSummaryRequest, getPayoutSummarySuccess, getPayoutSummaryFailure, getPayoutHistoryRequest, getPayoutHistorySuccess, getPayoutHistoryFailure, getPayoutByOrderHistoryRequest, getPayoutByOrderHistorySuccess, getPayoutByOrderHistoryFailure, getPayoutByOrderDownloadRequest, getPayoutByOrderDownloadSuccess, getPayoutByOrderDownloadFailure } from '../actions/paymentsPageActions';

const initialState = {
	payoutSummaryLoading: false,
	payoutSummaryRows: null,
	payoutSummaryError: '',
	payoutHistoryLoading: false,
	payoutHistoryRows: null,
	payoutHistoryRowsError: '',
	payoutByOrderHistoryLoading: false,
	payoutByOrderHistoryRows: null,
	payoutByOrderHistoryRowsError: '',
	payoutByOrderDownloadLoading: false,
	payoutByOrderDownloadRows: null,
	payoutByOrderDownloadRowsError: '',
	payoutByOrderDownloadSelection: [],
	payoutByOrderDownloadLoading: false
}

const paymentsPageReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(getPayoutSummaryRequest, (state) => {
			state.payoutSummaryLoading = true;
        }).addCase(getPayoutSummarySuccess, (state, action) => {
            state.payoutSummaryLoading = false;
            state.payoutSummaryRows= action.payload.data;
			state.payoutSummaryError = '';
        }).addCase(getPayoutSummaryFailure, (state, action) => {
            state.payoutSummaryLoading = false;
			state.payoutSummaryRows= '';
			state.payoutSummaryError = action.payload.error;
        })

		.addCase(getPayoutHistoryRequest, (state) => {
			state.payoutHistoryLoading = true;
        }).addCase(getPayoutHistorySuccess, (state, action) => {
            state.payoutHistoryLoading = false;
            state.payoutHistoryRows= action.payload.data;
			state.payoutHistoryRowsError = '';
        }).addCase(getPayoutHistoryFailure, (state, action) => {
            state.payoutHistoryLoading = false;
			state.payoutHistoryRows='';
			state.payoutHistoryRowsError = action.payload.error;
        })
		.addCase(getPayoutByOrderHistoryRequest, (state) => {
			state.payoutByOrderHistoryLoading = true;
        }).addCase(getPayoutByOrderHistorySuccess, (state, action) => {
            state.payoutByOrderHistoryLoading = false;
            state.payoutByOrderHistoryRows= action.payload.data;
			state.payoutByOrderHistoryRowsError = '';
        }).addCase(getPayoutByOrderHistoryFailure, (state, action) => {
            state.payoutByOrderHistoryLoading = false;
			state.payoutByOrderHistoryRows='';
			state.payoutByOrderHistoryRowsError = action.payload.error;
        })
		.addCase(getPayoutByOrderDownloadRequest, (state, action) => {
			state.payoutByOrderDownloadLoading = true;
			state.payoutByOrderDownloadSelection = action.payload.selectionValue
        }).addCase(getPayoutByOrderDownloadSuccess, (state, action) => {
            state.payoutByOrderDownloadLoading = false;
            state.payoutByOrderDownloadRows= action.payload.data;
			state.payoutByOrderDownloadRowsError = '';
        }).addCase(getPayoutByOrderDownloadFailure, (state, action) => {
            state.payoutByOrderDownloadLoading = false;
			state.payoutByOrderDownloadRows= {msg: 'error', details: action.payload.error};
			state.payoutByOrderDownloadRowsError = action.payload.error;
        })
		
		.addDefaultCase(() => { });
});
export default paymentsPageReducer;
